var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-switch',{attrs:{"value":_vm.form.active,"small":""},on:{"input":_vm.toggleWallActivity}})
}
var staticRenderFns = []

export { render, staticRenderFns }